import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { translations } from '../../../configs/translations'
import { Language } from '../../../context/LanguageContext'
import { VehicleService } from '../../../services/VehicleService'
import { FullVehicleSpec } from './FullVehicleSpec/FullVehicleSpec'
import { QuickVehicleSpec } from './QuickVehicleSpec/QuickVehicleSpec'
import './VehicleSpec.css'
import { VehicleSpecData } from './VehicleSpec.types'

export interface VehicleSpecProps {
	modelName: string
}

export const VehicleSpec = ({ modelName }: VehicleSpecProps) => {

	const [language, setLanguage] = useState<Language>('ru')
	const t = translations[language]

	const [openedPage, setOpenedPage] = useState<"quick" | "full">("quick")
	const [direction, setDirection] = useState<"opening" | "closing">("opening")

	const [vehicleSpec, setVehicleSpec] = useState<VehicleSpecData | null>(null)

	const togglePage = () => {
		const nextPage = openedPage === "quick" ? "full" : "quick"
		setDirection(nextPage === "full" ? "opening" : "closing")
		setOpenedPage(nextPage)
	}

	useEffect(() => {
		if (!modelName) return

		VehicleService.fetchVehicleStats(modelName)
			.then(setVehicleSpec)
			.catch((error) => {
				toast.error(
					error && error.response && error.response.data && t[error.response.data as keyof typeof t]
						? t[error.response.data as keyof typeof t]
						: t.error_unknown,
					{ className: 'notification-error' }
				)
			})
	}, [modelName])

	return (
		<>
			{vehicleSpec &&
				<div className='vehicle-specification'>
					<div className='vehicle-specification-header'>
						<p>{openedPage === 'quick' ? t.common_information : t.full_information}</p>
						<div
							className={`vehicle-specification-header-button${openedPage === 'full' ? ' vehicle-specification-header-button--active' : ''}`}
							onClick={togglePage}
						>
							<div className='vehicle-spec-icon' style={{ WebkitMaskImage: "url('../icons/32px/tune.webp')", maskImage: "url('../icons/32px/tune.webp')" }}></div>
						</div>
					</div>

					<div key={openedPage} className={`vehicle-specification-content vehicle-specification-content--${direction}`}>
						{
							openedPage === "quick" ? <QuickVehicleSpec vehicleSpec={vehicleSpec} /> : <FullVehicleSpec vehicleSpec={vehicleSpec} />
						}
					</div>
				</div>
			}
		</>
	)
}